import React from "react";
import { Outlet } from 'react-router-dom';
import NavBar from './Navbar';

const PublicLayout = () => {
    return (
        <>
            <header>
                <NavBar />
            </header>
            <main>
                <Outlet />
            </main>
        </>
    );
};

export default PublicLayout;